import styled from "styled-components"

export const Container = styled.div`
  max-width: 1170px;
  padding:  15px 15px 25px 15px;
  box-shadow: 0px 0 1px rgba(0,0,0,.18), 0px 0 1px rgba(0,0,0,.18);
  min-width: 240px;
  margin: 0 auto;
  @media(min-width: 768px){
    padding: 30px 30px 50px 30px;
  }
`

export const Title = styled.h1`
  width: 100%;
  text-align: center;
  font-size: 1.5rem;
`

export const HeaderContainer = styled.section`
  display: grid;
  justify-content: center;
  gap: 20px;
  text-align: center;
`

export const Price = styled.p`
  font-size: 1.5rem;
  font-weight: bold;
`

export const Img = styled.img`
  margin: 0 auto;
  width: 150px;
`

export const Info = styled.div`
  display: flex;
  font-size: 14px;
  background-color: #e1edff;
  color: #6083b7;
  border-radius: 8px;
  padding: 10px;
  
  strong{
    display: contents;
  }
`

export const PayState = styled.div`
  display: grid;
  align-items: center;
  gap: 10px;
  p{
    text-align: center;
  }
`

export const TitlePayState = styled.h1`
  width: 100%;
  text-align: center;
  font-size: 1.8rem;
  font-weight: bold;
`

export const ImgPayState = styled.img`
  margin: auto;
  width: 100%;
  max-width: 400px;
  min-width: 200px;
  height: auto;
  min-height: 100px;
  object-fit: contain;
`